function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

// src/array.ts
function getFirstItem(array) {
  return array != null && array.length ? array[0] : void 0;
}

function getLastItem(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : void 0;
}

function getPrevItem(index, array) {
  var loop = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var prevIndex = getPrevIndex(index, array.length, loop);
  return array[prevIndex];
}

function getNextItem(index, array) {
  var loop = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var nextIndex = getNextIndex(index, array.length, 1, loop);
  return array[nextIndex];
}

function removeIndex(array, index) {
  return array.filter(function (_, idx) {
    return idx !== index;
  });
}

function addItem(array, item) {
  return [].concat(_toConsumableArray(array), [item]);
}

function removeItem(array, item) {
  return array.filter(function (eachItem) {
    return eachItem !== item;
  });
}

function getNextIndex(currentIndex, length) {
  var step = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var loop = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var lastIndex = length - 1;

  if (currentIndex === -1) {
    return step > 0 ? 0 : lastIndex;
  }

  var nextIndex = currentIndex + step;

  if (nextIndex < 0) {
    return loop ? lastIndex : 0;
  }

  if (nextIndex >= length) {
    if (loop) return 0;
    return currentIndex > length ? length : currentIndex;
  }

  return nextIndex;
}

function getPrevIndex(index, count) {
  var loop = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  return getNextIndex(index, count, -1, loop);
}

function chunk(array, size) {
  return array.reduce(function (rows, currentValue, index) {
    if (index % size === 0) {
      rows.push([currentValue]);
    } else {
      rows[rows.length - 1].push(currentValue);
    }

    return rows;
  }, []);
}

function getNextItemFromSearch(items, searchString, itemToString, currentItem) {
  if (searchString == null) {
    return currentItem;
  }

  if (!currentItem) {
    var foundItem = items.find(function (item) {
      return itemToString(item).toLowerCase().startsWith(searchString.toLowerCase());
    });
    return foundItem;
  }

  var matchingItems = items.filter(function (item) {
    return itemToString(item).toLowerCase().startsWith(searchString.toLowerCase());
  });

  if (matchingItems.length > 0) {
    var nextIndex;

    if (matchingItems.includes(currentItem)) {
      var currentIndex = matchingItems.indexOf(currentItem);
      nextIndex = currentIndex + 1;

      if (nextIndex === matchingItems.length) {
        nextIndex = 0;
      }

      return matchingItems[nextIndex];
    }

    nextIndex = items.indexOf(matchingItems[0]);
    return items[nextIndex];
  }

  return currentItem;
}

export { getFirstItem, getLastItem, getPrevItem, getNextItem, removeIndex, addItem, removeItem, getNextIndex, getPrevIndex, chunk, getNextItemFromSearch };